export default class Thread {
  readonly id: number
  name: string
  readonly createdAt: string

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.name = data.name
    this.createdAt = data.createdAt
  }
}
